import React from 'react'
import PropTypes from 'prop-types'

import Box, { Types as BoxTypes } from './Box'

const Row = ({ children, gap = 24, ...rest }) => (
  <Box gap={gap} type={BoxTypes.ROW} {...rest}>{children}</Box>
)

Row.propTypes = {
  children: PropTypes.node,
  gap: PropTypes.number,
}

export default Row
